import React, { useEffect } from 'react';
import { Modal } from '@gerdau/hefesto';
import { InstabilityContent, ModalOverlay } from './styles';
import { useNavigationGuard } from '../../providers/navigationguard.provider';

export const GuardianCartModal = () => {
  const navigationGuard = useNavigationGuard();

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'visible';
    };
  }, []);

  return (
    <ModalOverlay>
      <Modal
        title="Pedido não finalizado"
        modalSize="sm"
        onClose={() => navigationGuard.cancelNavigation()}
        buttons={{
          left: {
            name: 'button-close-blocked-emitter',
            children: 'Sair sem finalizar o pedido',
            onClick: () => navigationGuard.confirmNavigation(),
            type: 'button'
          },
          right: {
            name: 'button-close-blocked-emitter',
            children: 'Continuar com o pedido',
            onClick: () => navigationGuard.cancelNavigation(),
            type: 'button'
          }
        }}
      >
        <InstabilityContent>
          <span>Tem certeza que deseja sair sem finalizar seu pedido?</span>
          <span>Você poderá continuar seu pedido em até 6 horas.</span>
        </InstabilityContent>
      </Modal>
    </ModalOverlay>
  );
};
